<template>
  <form class="form">
    <FormInput :label="$t('form.label.category.title')" v-model="form.fields.title" name="title" required/>
    <FormFile :label="$t('form.label.icon')" v-model="form.fields.icon" name="icon" accept=".png,.svg"
              :maxSize="500" :message="$t('form.messages.500_ko_png_svg')" required preview/>
  </form>
</template>

<script>
import {FormFile, FormInput} from '@/components/form/fields'
import FormValidMixin from '@/components/form/mixins/FormValidMixin.js'

export default {
  name: 'AddEditCategory',
  mixins: [FormValidMixin],
  components: {
    FormFile,
    FormInput
  },
  data() {
    return {
      form: {
        fields: {
          title: {
            value: '',
            valid: false
          },
          icon: {
            file: '',
            previewName: null,
            previewUrl: null,
            value: '',
            valid: false
          },
        },
        submitted: false
      },
    }
  },
  methods: {
    messageToTooltip() {
      const title = this.form.fields.title.value

      if (this.$route.query.action === this.$query.ACTION.EDIT) {
        return this.$popup.report(`${title} ${this.$t('popup.modifiedElement')}`, false)
      }

      this.$popup.report(`${title} ${this.$t('popup.createdElement')}`, false)

    },
    async submit() {
      if (this.form.valid) {
        this.form.submitted = true

        const formData = {
          title: this.form.fields.title.value
        }

        let currentId
        this.$route.query.action === this.$query.ACTION.EDIT
            ? currentId = await this.$category.update(this.$route.query.id, formData)
            : currentId = await this.$category.store(formData)

        if (this.form.fields.icon.file) {
          await this.$category.uploadIcon(currentId, this.form.fields.icon.file[0])
        }

        this.form.submitted = false

        this.messageToTooltip()
      }
    }
  },
  mounted() {
    if (this.$route.query.action === this.$query.ACTION.EDIT && this.$category.all) {

      const category = this.$category.all.find(({id}) => id.toString() === this.$route.query.id.toString())

      this.form.fields.title = {valid: true, value: category.title}
      this.form.fields.icon = {valid: true, previewName: category.icon.name, previewUrl: category.icon.url}
    }
  }
}
</script>